<template>
	<div class="md-layout md-gutter" style="min-height: 80vh;">
		<MenuLayout>
			<div slot="slotForm">
				<div class="md-layout md-gutter md-alignment-center" style="display: list-item;">
					<md-card class="md-layout-item md-medium-size-75 md-small-size-75 md-xsmall-size-75 md-alignment-center" 
						style="width: 75%; margin-left: 12%;" md-with-hover>
						<md-card-expand>
							<md-card-actions style="height: 80px;padding-top: 4%;margin-left: -8%;">
								<h3 style="width: 90%; margin: 0%; color: '#2c3e50'"> Filtros </h3>
								<md-card-expand-trigger>
									<md-button class="md-icon-button btn-expand">
										<md-icon>keyboard_arrow_down</md-icon>
									</md-button>
								</md-card-expand-trigger>
							</md-card-actions>
							<md-card-expand-content>
								<md-card-content>
									<div class="md-layout-item" style="display: flex;">
										<md-switch v-model="plantaAbateEnabled" class="md-primary" style="margin-top: 25px;"></md-switch>
										<md-field style="margin-bottom: 0; width: 47%;">
											<label for="plantaAbate">Planta de Abate</label>
											<md-select v-model="plantaAbate" name="plantaAbate" id="plantaAbate" md-dense :disabled="!plantaAbateEnabled">
												<md-option v-for="plantaAbate in plantasAbate" :key="plantaAbate.idPlantaAbate" 
													:value="plantaAbate.idPlantaAbate" style="width: 100%;">
													SIF {{ plantaAbate.nrRegistroSif }} - {{ plantaAbate.nmPlantaAbate }} 
												</md-option>
											</md-select>
										</md-field>
										<div style="margin-left: 4%;">
											<md-radio v-model="radio" value="Pizza">Grafico de Pizza</md-radio>
											<md-radio v-model="radio" value="Column">Grafico de Coluna</md-radio>
										</div>
										<div style="margin-left: 4%;">
											<md-radio v-model="visualizacao" value="condenas">Condenas</md-radio>
											<md-radio v-model="visualizacao" value="destinos">Destinos</md-radio>
											<md-radio v-model="visualizacao" value="cooperativas">Cooperativas</md-radio>
										</div>
									</div>
									<div class="md-layout-item" style="display: flex;">
										<md-switch v-model="tipoCondenacaoEnabled" class="md-primary" style="margin-top: 25px;"></md-switch>
										<md-field style="margin-bottom: 0;">
											<label for="tipoCondenacao">Tipos de Condenação</label>
											<md-select v-model="tipoCondenacao" name="tipoCondenacao" id="tipoCondenacao" 
												:disabled="!tipoCondenacaoEnabled">
												<md-option v-for="tipoCondenacao in tiposCondenacao" :key="tipoCondenacao.idTipoCondenacao" 
													:value="tipoCondenacao.idTipoCondenacao" style="width: 100%;">
													{{ tipoCondenacao.dsTipoCondenacao }}
												</md-option>
											</md-select>
										</md-field>
										<md-switch v-model="tipoDestinoEnabled" class="md-primary" style="margin-top: 25px; margin-right: -5px; margin-left: 10px;"></md-switch>
										<md-field style="margin-left: 1%; margin-bottom: 0;">
											<label for="tipoDestino">Tipos de Destino</label>
											<md-select v-model="tipoDestino" name="tipoDestino" id="tipoDestino" 
												:disabled="!tipoDestinoEnabled">
												<md-option v-for="tipoDestino in tiposDestino" :key="tipoDestino.idTipoDestino" 
													:value="tipoDestino.idTipoDestino" style="width: 100%;">
													{{ tipoDestino.dsTipoDestino }}
												</md-option>
											</md-select>
										</md-field>
									</div>
									<div class="md-layout-item" style="display: flex;">
										<md-switch v-model="dtInicioEnabled" class="md-primary" style="margin-top: 25px;"></md-switch>
										<md-datepicker id="dtInicio" style="width: 50%; margin-bottom: 0;" language="pt-br" 
											:format="customFormatter" v-model="dtInicio" :disabled="!dtInicioEnabled">
											<label>Data Início</label>
										</md-datepicker>
										<md-switch v-model="dtFimEnabled" class="md-primary" style="margin-top: 25px; margin-right: -5px; margin-left: 10px;"></md-switch>
										<md-datepicker id="dtFim" style="width: 50%; margin-left: 1%; margin-bottom: 0;" language="pt-br" 
											:format="customFormatter" v-model="dtFim" :disabled="!dtFimEnabled">
											<label>Data Fim</label>
										</md-datepicker>
									</div>
									<div class="md-layout-item" style="display: flex; float: right; margin: 1%;">
										<md-button class="md-raised md-primary" @click.native="realizarPesquisa">Pesquisar</md-button>
									</div>
								</md-card-content>
							</md-card-expand-content>
						</md-card-expand>
						<div class="loading-overlay md-accent" v-if="exibeSpinner">
							<md-progress-spinner md-mode="indeterminate" :md-stroke="2"></md-progress-spinner>
						</div>
					</md-card>
				</div>
				<div class="md-layout md-gutter md-alignment-center" style="display: list-item;;">
					<md-card v-show="chartData != ''" class="md-layout-item md-medium-size-100 md-small-size-100 md-xsmall-size-100" style="margin-left: 20px; margin-right: 20px; margin-top: 20px;" md-with-hover>
						<div>
							<div class="md-layout md-gutter md-alignment-center" id="chart" style="width: 100%; height: 600px;"></div>
						</div>
					</md-card>
				</div>
			</div>
		</MenuLayout>
	</div>
</template>

<style scoped>

</style>

<style>
	.md-switch {
		display: flex;
	}
	.md-select {
		top: 160px;
	}
	.md-menu-content {
		max-width: 500px;
	}
	.md-input {
		font-size: 14px;
	}

	.md-field.md-focused .md-input, .md-field.md-focused .md-textarea, .md-field.md-has-value .md-input, .md-field.md-has-value .md-textarea {
		font-size: 14px;
	}

	.md-progress-bar {
		margin: 24px;
	}

	.loading-overlay {
		z-index: 10;
		top: 0;
		left: 0;
		right: 0;
		position: absolute;
		width: 100%;
		height: 100%;
		background: rgba(255, 255, 255, 0.9);
		display: flex;
		align-items: center;
		justify-content: center;
	}
</style>

<script>

import Vue from 'vue'
import MenuLayout from '.././components/MenuLayout'

export default {
	name: 'CondenacoesTotais',

	components: {
		MenuLayout
	},

	methods: {
		drawChart: function() {
			var totalData = [];
			this.chartData.forEach(function(item){
				var newItem = [item[0], item[1]];
				if (newItem[0]==null) newItem[0] = "Indisponível"
				totalData.push(newItem);
			})
			var data = google.visualization.arrayToDataTable(
				totalData
			);

			if (this.radio == "Pizza")
			{
				var options = {
					height: '600px',
					title: 'Valores',
					titleTextStyle: {
						color: '#212121',
						fontSize: '17',
						fontName: 'Helvetica'
					},
					legend: {
						alignment: 'start',
						position: 'bottom',
						textStyle: {
							color: '#212121',
							fontSize: '12'
						}
					},
					tooltip: {
						showColorCode: true
					},
					chartArea: {
						width: '96%',
						height: '85%'
					}
				};

				if (data.getNumberOfRows() == 0){
					$("#chart").html('<h2 class="md-layout-item md-alignment-center" style="display: contents;">Nenhum Registro!</h2>')
				}
				else {
					var chart = new google.visualization.PieChart(document.getElementById('chart'));
					chart.draw(data, options);
				}
			}
			else
			{
				var options = {
					height: '600px',
					title: 'Valores',
					titleTextStyle: {
						color: '#212121',
						fontSize: '17',
						fontName: 'Helvetica'
					},
					legend: {
						alignment: 'start',
						position: 'in',
						textStyle: {
							color: '#212121',
							fontSize: '12'
						}
					},
					hAxis: {
						textStyle: {
							color: '#212121',
							fontSize: '11',
							fontName: 'Helvetica'
						}
					},
					tooltip: {
						showColorCode: true
					},
					chartArea: {
						width: '90%',
						height: '75%',
						top: '10%'
					}
				};

				if (data.getNumberOfRows() == 0){
					$("#chart").html('<h2 class="md-layout-item md-alignment-center" style="display: contents;">Nenhum Registro!</h2>')
				}
				else {
					var chart = new google.visualization.ColumnChart(document.getElementById('chart'));
					chart.draw(data, options);
				}
			}			
		},
		formatDate: function(date) {
			var d = new Date(date),
				month = '' + (d.getMonth() + 1),
				day = '' + d.getDate(),
				year = d.getFullYear();

			if (month.length < 2) month = '0' + month;
			if (day.length < 2) day = '0' + day;

			return [year, month, day].join('');
		},
		realizarPesquisa: function() {
			var _this = this;
			var formData = new FormData();
			this.exibeSpinner = true;
			var args = "";
			var params = "";
			if (args == "")
			{
				if (_this.plantaAbateEnabled && _this.plantaAbate != "")
					args = args + 'cd_planta=' + _this.plantaAbate;
			}
			else
			{
				if (_this.plantaAbateEnabled && _this.plantaAbate != "")
					args = args + '&cd_planta=' + _this.plantaAbate;
			}
			if (args == "")
			{
				if (_this.tipoCondenacaoEnabled && _this.tipoCondenacao != "")
					args = args + 'cd_tipo=' + _this.tipoCondenacao;
			}
			else
			{
				if (_this.tipoCondenacaoEnabled && _this.tipoCondenacao != "")
					args = args + '&cd_tipo=' + _this.tipoCondenacao;
			}
			if (args == "")
			{
				if (_this.tipoDestinoEnabled && _this.tipoDestino != "")
					args = args + 'cd_destino=' + _this.tipoDestino;
			}
			else
			{
				if (_this.tipoDestinoEnabled && _this.tipoDestino != "")
					args = args + '&cd_destino=' + _this.tipoDestino;
			}
			if (args == "")
			{
				if (_this.dtInicioEnabled && _this.dtInicio != null)
					args = args + 'dt_inicial=' + this.formatDate(this.dtInicio);
			}
			else
			{
				if (_this.dtInicioEnabled && _this.dtInicio != null)
					args = args + '&dt_inicial=' + this.formatDate(this.dtInicio);
			}
			if (args == "")
			{
				if (_this.dtFimEnabled && _this.dtFim != null)
					args = args + 'dt_final=' + this.formatDate(this.dtFim);
			}
			else
			{
				if (_this.dtFimEnabled && _this.dtFim != null)
					args = args + '&dt_final=' + this.formatDate(this.dtFim);
			}
			if (args == "")
			{
					args = args + 'view=' + this.visualizacao;
			}
			else
			{
					args = args + '&view=' + this.visualizacao;
			}
			if (args != "")
			{
				params = "?" + args;
			}
			_this.successMessages = []
			_this.errorMessages = []
			var settings = {
				url : _this.$root.urlAPI + 'condenas/total/' + params,
				type : 'GET',
				headers: {
					'Authorization': 'Bearer ' + _this.$root.accessToken
				},
				processData: false,
				contentType: false,
			}
			$.ajax(settings)
				.done( function(data) {
					var firstValue = ['Tipo', 'Número'];
					data.unshift(firstValue);
					
					_this.chartData = data;
					_this.exibeSpinner = false;
				})
				.fail (function(data) {
					if(data.status == 401){
						_this.$router.push('/');
					}
					else if(data.status == 500){
						var item= {
							message: "Houve um erro ao tentar importar o arquivo selecinado, tente novamente ou entre em contato com o Suporte"
						};
						_this.errorMessages.push(item);
					}
					else {
						var errors = JSON.parse(data.responseText);
						var item= {
							message: errors.msg
						};
						_this.errorMessages.push(item);
					}
					_this.exibeSpinner = false;
				})
		},
		customFormatter(date) {
			return moment(date).format('dd/MM/yyyy');
		},
		getPlantaAbate: function () {
			var _this = this;
			_this.sifes = [];
			var settings = {
				url: _this.$root.urlAPI + 'plantas/',
				type: 'GET',
				headers: {
					'content-type': 'application/json',
					'Authorization': 'Bearer ' + _this.$root.accessToken
				}
			}
			$.ajax(settings)
				.done(function (response) {
					response.forEach(function (item) {
						var registroSif = {
							idPlantaAbate: item.id_planta_abate,
							nmPlantaAbate: item.nm_planta_abate,
							nrRegistroSif: item.nr_registro_sif
						};
						_this.plantasAbate.push(registroSif);
					});
				})
				.fail(function (response) {
					_this.$parent.msgErrorSistema = 'Erro ao carregar a lista de Plantas de Abate!';
					_this.$parent.$refs.msgErrorSistema.open();
				})
		},
		getTipoCondenacao: function () {
			var _this = this;
			_this.tipoCondenacao = ""
			_this.tiposCondenacao = [];
			var settings = {
				url: _this.$root.urlAPI + 'condenas/',
				type: 'GET',
				headers: {
					'content-type': 'application/json',
					'Authorization': 'Bearer ' + _this.$root.accessToken
				}
			}
			$.ajax(settings)
				.done(function (response) {
					if(response.length > 0){
						response.forEach(function (item) {
							var registroLocal = {
								idTipoCondenacao: item.cd_tipo_condenacao,
								dsTipoCondenacao: item.ds_tipo_condenacao
							};
							_this.tiposCondenacao.push(registroLocal);
						});
					}
				})
				.fail(function (response) {
					_this.$parent.msgErrorSistema = 'Erro ao carregar lista de Tipos de Condenação!';
					_this.$parent.$refs.msgErrorSistema.open();
				})
		},
		getTipoDestino: function () {
			var _this = this;
			_this.tipoDestino = ""
			_this.tiposDestino = [];
			var settings = {
				url: _this.$root.urlAPI + 'destinos/',
				type: 'GET',
				headers: {
					'content-type': 'application/json',
					'Authorization': 'Bearer ' + _this.$root.accessToken
				}
			}
			$.ajax(settings)
				.done(function (response) {
					if(response.length > 0){
						response.forEach(function (item) {
							var registroLocal = {
								idTipoDestino: item.id_destino_carcaca,
								dsTipoDestino: item.ds_destino_carcaca
							};
							_this.tiposDestino.push(registroLocal);
						});
					}
				})
				.fail(function (response) {
					_this.$parent.msgErrorSistema = 'Erro ao carregar lista de Tipos de Destino!';
					_this.$parent.$refs.msgErrorSistema.open();
				})
		},
		userLogged: function() {
			this.getPlantaAbate();
			this.getTipoCondenacao();
			this.getTipoDestino();
			this.realizarPesquisa();
			document.getElementsByClassName('btn-expand')[0].click();
		}
	},

	mounted() {
		this.$material.locale.shorterMonths = ['Jan', 'Fev', 'Mar', 'Abril','Maio', 'Jun', 'Jul','Ago', 'Set', 'Out','Nov','Dez'];
		this.$material.locale.shortMonths = ['Jan', 'Fev', 'Mar', 'Abril','Maio', 'Jun', 'Jul','Ago', 'Set', 'Out','Nov','Dez'];
		this.$material.locale.months = ['Janeiro', 'Fevereiro', 'Março', 'Abril','Maio', 'Junho', 'Julho','Agosto', 'Setembro', 'Outubro','Novembro','Dezembro'];
		this.$material.locale.shorterDays = ['D', 'S', 'T', 'Q', 'Q','S','S'];
		this.$material.locale.days = ['Domingo','Segunda', 'Terça', 'Quarta', 'Quinta','Sexta', 'Sabado'];
		this.$material.locale.shortDays = ['Dom','Seg', 'Ter', 'Qua', 'Qui','Sex', 'Sab'];
		if (this.$root.verifyUserLogged())
		{
			this.userLogged();
		}
	},

	watch : {
		'chartData': function(newVal, oldVal) {
			if (newVal != oldVal)
			{
				google.charts.load('current', {'packages':['corechart']});
				google.charts.setOnLoadCallback(this.drawChart);
			}
		},
		'plantaAbateEnabled': function(newVal, oldVal) {
			if(newVal == false)
			{
				this.plantaAbate = '';
			}
		},
		'tipoCondenacaoEnabled': function(newVal, oldVal) {
			if(newVal == false)
			{
				this.tipoCondenacao = '';
			}
		},
		'tipoDestinoEnabled': function(newVal, oldVal) {
			if(newVal == false)
			{
				this.tipoDestino = '';
			}
		},
		'dtInicioEnabled': function(newVal, oldVal) {
			if(newVal == false)
			{
				if(document.getElementsByClassName('md-clear').length > 1)
				{
					var elements = document.getElementsByClassName('md-clear');
					for(let element of elements) {
						if (element.parentElement.id == 'dtInicio')
						{
							element.click();
						}
					}
				}
				else
				{
					document.getElementsByClassName('md-clear')[0].click();
				}
			}
			else
			{
				var date = Date();
				var newdate = new Date(date);
				newdate.setDate(newdate.getDate() - 15);
				this.dtInicio = newdate;
			}
		},
		'dtFimEnabled': function(newVal, oldVal) {
			if(newVal == false)
			{
				if(document.getElementsByClassName('md-clear').length > 1)
				{
					var elements = document.getElementsByClassName('md-clear');
					for(let element of elements) {
						if (element.parentElement.id == 'dtFim')
						{
							element.click();
						}
					}
				}
				else
				{
					document.getElementsByClassName('md-clear')[0].click();
				}
			}
			else
			{
				var date = Date();
				var newdate = new Date(date);
				newdate.setDate(newdate.getDate());
				this.dtFim = Date();
			}
		}
	},

	computed : {

  	},

  	data() {
		return {
			plantaAbateEnabled: false,
			plantasAbate: [],
			plantaAbate: '',
			tiposCondenacao: [],
			tipoCondenacao: '',
			tipoCondenacaoEnabled : false,
			tiposDestino: [],
			tipoDestino: '',
			tipoDestinoEnabled : false,
			dtInicioEnabled: false,
			dtInicio: null,
			dtFimEnabled: false,
			dtFim: null,
			errorMessages: [],
			successMessages: [],
			exibeSpinner: false,
			chartData: [],
			radio: "Pizza",
			visualizacao: "condenas"
		}
	}
}

</script>




// WEBPACK FOOTER //
// src/components/CondenacoesTotais.vue